import { z } from "zod";
import { createDocumentSchema } from "./FormGroups/DocumentFormGroup";
import { createQuickChanceSchema } from "./FormGroups/QuickChanceFormGroup";
import { createOperationalOrganizationIdsSchema } from "../Shared/FormGroups/OperationalOrganizationsFormGroup";
import { TFunction } from "i18next";
import { executiveSummarySchema } from "../Shared/FormGroups/ExecutiveSummaryFormGroup";
import { t as translate } from "i18next";

export const createFormSchema = (t: TFunction, aiImportID: string | null) => {
  const baseSchema = z.object({
    ...createQuickChanceSchema(t).shape,
    ...createOperationalOrganizationIdsSchema(t).shape,
    ...executiveSummarySchema.shape,
  });

  const schemaWithDocuments = aiImportID
    ? baseSchema
    : baseSchema.extend({
      ...createDocumentSchema(t).shape,
    });

  return schemaWithDocuments;
};

export const formGroupSchemas = {
  document: createDocumentSchema(translate),
  operationalOrganizationIds: createOperationalOrganizationIdsSchema(translate),
  quick: createQuickChanceSchema(translate),
  executiveSummary: executiveSummarySchema,
};
